import React from 'react';
import { PropTypes } from 'prop-types';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const ViewModeTooltip = ({
  id,
  label,
  children,
  place = 'top',
  tooltipClassName = '',
}) => (
  <>
    <span
      data-tooltip-id={id}
      data-tooltip-content={label}
      data-tooltip-place={place}
      className="inline-flex"
    >
      {children}
    </span>
    <Tooltip
      id={id}
      className={`${tooltipClassName} z-[9999]`}
    />
  </>
);

ViewModeTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  place: PropTypes.oneOf([
    'top', 'top-start', 'top-end',
    'right', 'right-start', 'right-end',
    'bottom', 'bottom-start', 'bottom-end',
    'left', 'left-start', 'left-end',
  ]),
  tooltipClassName: PropTypes.string,
};

export default ViewModeTooltip;
